/* eslint-disable quotes */
import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import { Header, Menus } from '../layouts/index'
import React, { useEffect, useState } from 'react'
import Profile from '../pages/profile/profile'
import KnowledgeArticles from '../components/ka/knowledgeinnerview'
import { Login } from '../pages/login/login'
import RecentlyQuestionsInnerview from '../components/recently-asked-questions/recently-asked-questions-innerview'
import TrendingQuestionsInnerview from '../components/trending-questions/trendinginnerview'
import Settings from '../pages/settings/settings'
import  Home  from '../pages/home/home'
import ClassificationBanner from '../layouts/classification-banner/classification-banner'
const Routers = () => {
    const [ isOpen, setIsOpen] = useState<any>(false)
    
    return (
            <Router>
                <div className='mainWrapper' id='mainWrapper'>
                    <ClassificationBanner/>
                    <Menus setIsOpen={setIsOpen} isOpen={isOpen}/>
                    <div className='content-wrapper'>
                        {/* <Header loginUserRoles={loginUserRoles} loginusers={setLoginUserRoles} /> */}
                        <Header />
                        <div className='wrapper' id='wrapper'>
                          <Routes>
                              <Route path="/" element={<Home setIsOpen={setIsOpen} isOpen={isOpen}/>} />
                              <Route path="/settings" element={<Settings />} />
                              <Route path="/knowledgearticles" element={<KnowledgeArticles />} />
                              <Route path="/recentlyaskedquestions" element={<RecentlyQuestionsInnerview />} />
                              <Route path="/trendingaskedquestions" element={<TrendingQuestionsInnerview />} />
                          </Routes>
                        </div>
                    </div>
                </div>
            </Router>
    )
}

export default Routers